var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("EditSourceDialog", { ref: "editSourceDialog" }),
      _vm._v(" "),
      _c(
        "v-card-actions",
        { staticClass: "card-bg-1 py- layout wrap" },
        [
          _c("AutoAssignDialog", {
            attrs: {
              selectionCounter: _vm.selectionCounter,
              selected: _vm.selected,
              items: _vm.items,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "align-baseline py-2" },
        [
          _c(
            "v-item-group",
            {
              attrs: { mandatory: "", "active-class": "white--text" },
              model: {
                value: _vm.filterToggle,
                callback: function ($$v) {
                  _vm.filterToggle = $$v
                },
                expression: "filterToggle",
              },
            },
            [
              _c(
                "v-subheader",
                { staticStyle: { display: "inline", cursor: "default" } },
                [_vm._v("Show:")]
              ),
              _vm._v(" "),
              _c("v-item", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ active, toggle }) {
                      return _c(
                        "v-chip",
                        {
                          staticClass: "chipFilter clickable",
                          attrs: {
                            small: "",
                            color: active ? "primary" : "default",
                            selected: active,
                          },
                          on: { click: toggle },
                        },
                        [_vm._v("All")]
                      )
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("v-item", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ active, toggle }) {
                      return _c(
                        "v-chip",
                        {
                          staticClass: "chipFilter clickable",
                          attrs: {
                            small: "",
                            color: active ? "primary" : "default",
                            selected: active,
                          },
                          on: { click: toggle },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "pr-2",
                              class: {
                                "error--text font-weight-bold":
                                  _vm.unassignedLength > 0,
                              },
                              staticStyle: { float: "left" },
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(_vm.unassignedLength)
                              ),
                            ]
                          ),
                          _vm._v("\n          Unassigned\n        "),
                        ]
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "rounded emphasize-clear",
            attrs: {
              "prepend-inner-icon": "search",
              clearable: "",
              solo: "",
              placeholder: "Search data sources",
              "hide-details": "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-",
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredItems,
          pagination: _vm.pagination,
          search: _vm.search,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "headers",
            fn: function (props) {
              return [
                _c(
                  "tr",
                  [
                    _c(
                      "th",
                      [
                        _c("v-checkbox", {
                          attrs: {
                            color: "primary",
                            "input-value": _vm.hasEvery,
                            indeterminate: _vm.hasSome,
                            primary: "",
                            "hide-details": "",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleAll()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(props.headers, function (header) {
                      return _c(
                        "th",
                        {
                          key: header.text,
                          class: [
                            "column",
                            header.sortable && "sortable",
                            _vm.pagination.descending ? "desc" : "asc",
                            header.value === _vm.pagination.sortBy
                              ? "active"
                              : "",
                            `text-xs-${header.align}`,
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.changeSort(
                                header.sortable,
                                header.value
                              )
                            },
                          },
                        },
                        [
                          header.sortable
                            ? _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("arrow_upward"),
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n          " + _vm._s(header.text) + "\n        "
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ]
            },
          },
          {
            key: "items",
            fn: function ({ item }) {
              return [
                _c(
                  "td",
                  [
                    _c("v-checkbox", {
                      staticClass: "clickable",
                      attrs: {
                        "input-value": _vm.selected[item.id],
                        color: "primary",
                        primary: "",
                        "hide-details": "",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleRow(item)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [
                  _c("strong", [_vm._v(_vm._s(item.LocationIdentifier))]),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    item.MonitoringFeatureId
                      ? [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("open_in_new"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: {
                                target: "_blank",
                                to: {
                                  name: "monitoringfeature",
                                  params: {
                                    monitoringFeatureId:
                                      item.MonitoringFeatureId,
                                  },
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.locationName) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      : _c(
                          "v-chip",
                          {
                            attrs: {
                              outline: "",
                              color: "error",
                              small: "",
                              label: "",
                            },
                          },
                          [_vm._v("\n          Unassigned\n        ")]
                        ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("td", [
                  _vm._v("\n        " + _vm._s(item.dataType) + "\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { "open-delay": 500, left: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editItem(item)
                                          },
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "warning" } },
                                        [_vm._v("edit")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("Button.Edit")))]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }